import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_EMAIL_WORKFLOWS = registerQuery({
  fieldName: 'emailWorkflows',
  args: ['emailId'],
  fetcher({
    emailId
  }) {
    return http.get(`cosemail/v1/emails/${emailId}/workflows`);
  }
});
export const GET_EMAIL_GOALS_AND_CAMPAIGNS = registerQuery({
  fieldName: 'emailGoalsAndCampaigns',
  args: ['flowId'],
  fetcher({
    flowId
  }) {
    return http.get(`automationreporting/v1/goals/${flowId}/goal-counts-and-email-campaigns`);
  }
});

// https://git.hubteam.com/HubSpot/Email/blob/395bcc850b414bb895bc23c25f0037db773be356/EmailData/src/main/java/com/hubspot/email/campaigns/EmailCampaignStats.java#L25

export const GET_EMAIL_CLICK_THROUGH_RATIO = registerQuery({
  fieldName: 'emailClickThroughRatio',
  args: ['campaignId'],
  fetcher({
    campaignId
  }) {
    return http.get(`email/v1/campaigns/stats?emailCampaignIds=${campaignId}`).then(({
      stats: [emailCampaign]
    }) => {
      if (!emailCampaign) {
        return undefined;
      }
      const {
        fullCounters: {
          click,
          delivered
        }
      } = emailCampaign;
      let clickThroughRatio = 0;
      if (delivered !== null && delivered > 0) {
        clickThroughRatio = (click || 0) / delivered;
      }
      return clickThroughRatio;
    });
  }
});